import React from "react";
import Logo from "../assets/Logo.svg";
import styles from "./PublicLayout.module.css";
import { Link } from "react-router-dom";

export default function FooterCommon() {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerInner}>
        {/* Brand col */}
        <div className={styles.footerBrand}>
          <img src={Logo} alt="SugarCribs" className={styles.footerLogo} />
          <p className={styles.footerTagline}>
            The exclusive platform<br />for premium connections.
          </p>
          <div className={styles.footerSocialRow}>
            {/* X / Twitter */}
            <a
              href="https://x.com/sugarcribs"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.socialIcon}
              aria-label="Follow us on X"
              id="footer-social-x"
            >
              <img src="/images/X-icon.png" alt="X" className={styles.socialImg} />
            </a>
            {/* Instagram */}
            <a
              href="https://instagram.com/sugarcribs"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.socialIcon}
              aria-label="Follow us on Instagram"
              id="footer-social-instagram"
            >
              <img src="/images/Insta-icon.png" alt="Instagram" className={styles.socialImg} />
            </a>
          </div>
        </div>

        {/* Explore col */}
          <div className={styles.footerCol}>
            <h4 className={styles.footerColTitle}>Explore</h4>
            <ul className={styles.footerLinks}>
              <li><Link to="/the-vault" className={styles.footerLink}>The Vault</Link></li>
              <li><Link to="/virtual-companionship" className={styles.footerLink}>Virtual Companionship</Link></li>
              <li><Link to="/lifestyle-and-luxury-travel" className={styles.footerLink}>Lifestyle &amp; Luxury Travel</Link></li>
              <li><Link to="/fine-art-glamour" className={styles.footerLink}>Fine Art Glamour</Link></li>
            </ul>
          </div>

          {/* Company col */}
          <div className={styles.footerCol}>
            <h4 className={styles.footerColTitle}>Company</h4>
            <ul className={styles.footerLinks}>
              <li><Link to="/about-us" className={styles.footerLink}>About Us</Link></li>
              <li><Link to="/creators" className={styles.footerLink}>Creator Application</Link></li>
              <li><Link to="/newsletter" className={styles.footerLink}>Join Our Newsletter</Link></li>
              <li><a href="mailto:support@sugarcribs.com" className={styles.footerLink}>Contact</a></li>
            </ul>
          </div>

          {/* Legal col */}
          <div className={styles.footerCol}>
            <h4 className={styles.footerColTitle}>Legal</h4>
            <ul className={styles.footerLinks}>
              <li><Link to="/terms-of-service" className={styles.footerLink}>Terms of Service</Link></li>
              <li><Link to="/privacy-policy" className={styles.footerLink}>Privacy Policy</Link></li>
              <li><Link to="/DMCA-takedown-policy" className={styles.footerLink}>DMCA</Link></li>
              <li><Link to="/compliance-statement" className={styles.footerLink}>Compliance</Link></li>
            </ul>
          </div>
      </div>

      {/* Bottom bar */}
      <div className={styles.footerBottom}>
        <p>© {new Date().getFullYear()} SugarCribs. All rights reserved.</p>
      </div>
    </footer>
  );
}
